import { render, staticRenderFns } from "./userInfoFansList.vue?vue&type=template&id=c8970800&scoped=true&"
import script from "./userInfoFansList.vue?vue&type=script&lang=js&"
export * from "./userInfoFansList.vue?vue&type=script&lang=js&"
import style0 from "./userInfoFansList.vue?vue&type=style&index=0&id=c8970800&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8970800",
  null
  
)

export default component.exports